// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2T6jH","left":"styles_left__2aCvU"};